// @flow
import {
  SET_COMPANY_INFO,
  UPDATE_COMPANY_LICENCE,
  UPDATE_COMPANY_CHILD,
  UPDATE_COMPANY_FACEBASE,
  UPDATE_COMPANY_USER,
  UPDATE_LICENCET_ITEM,
  REMOVE_COMPANY_LICENCE,
  EDIT_COMPANY_FACEBASE,
  REMOVE_COMPANY_USER
} from "../../global/actions/actionNames";

const initialState = {
  name: ""
};

const companyReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case SET_COMPANY_INFO:
      if (actions.company !== null) {
        let reseller = null;
        if (actions.company.companyType === "RESELLER") {
          reseller = actions.company.authorisedReseller;
        } else {
          reseller = state.reseller;
        }
        if (actions.infoOnly) {
          actions.company.facebases = { ...state.facebases };
          actions.company.licences = { ...state.licences };
          actions.company.children = { ...state.children };
          actions.company.users = { ...state.users };
        }
        return {
          ...state,
          ...actions.company,
          reseller: reseller
        };
      }
      return state;

    case UPDATE_COMPANY_LICENCE:
      if (actions.data !== null && actions.data.id !== null && state.licences) {
        let licences = [...state.licences.edges];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.node.id === actions.data.id);
          if (index > -1) {
            licences[index].node = actions.data;
          } else {
            licences.push({ node: actions.data });
          }
        } else {
          licences.push({ node: actions.data });
        }
        return {
          ...state,
          licences: { edges: licences }
        };
      }
      return state;

    case UPDATE_COMPANY_CHILD:
      if (actions.company !== null && actions.company.id !== null) {
        let children = [...state.children.edges];
        if (children.length > 0) {
          let index = children.findIndex(x => x.node.id === actions.company.id);
          if (index > -1) {
            children[index].node = actions.company;
          } else {
            children.push({ node: actions.company });
          }
        } else {
          children.push({ node: actions.company });
        }
        return {
          ...state,
          children: { edges: children }
        };
      }
      return state;

    case UPDATE_COMPANY_FACEBASE:
      if (actions.facebase !== null && actions.facebase.id !== null) {
        let facebases = [...state.facebases.edges];
        if (facebases.length > 0) {
          let index = facebases.findIndex(
            x => x.node.id === actions.facebase.id
          );
          if (index > -1) {
            facebases[index].node = actions.facebase;
          } else {
            facebases.push({ node: actions.facebase });
          }
        } else {
          facebases.push({ node: actions.facebase });
        }
        return {
          ...state,
          facebases: { edges: facebases }
        };
      }
      return state;

    case UPDATE_COMPANY_USER:
      if (actions.user !== null && actions.userId !== null) {
        let users = [...state.users.edges];
        if (users.length > 0) {
          let index = users.findIndex(x => x.node.id === actions.userId);
          if (index > -1) {
            let user = { ...users[index].node, ...actions.user };
            users[index] = { node: user };
          } else {
            users.push({ node: actions.user });
          }
        } else {
          users.push({ node: actions.user });
        }
        return {
          ...state,
          users: { edges: users }
        };
      }
      return state;

    case UPDATE_LICENCET_ITEM:
      if (
        actions.licenceId !== undefined &&
        actions.fieldName !== undefined &&
        actions.value !== undefined
      ) {
        let licences = [...state.licences.edges];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.node.id === actions.licenceId);
          if (index > -1) {
            let licence = { ...licences[index] };
            licence.node[actions.fieldName] = actions.value;

            licences[index] = licence;
            return {
              ...state,
              licences: { edges: licences }
            };
          }
        }
      }
      return state;

    case REMOVE_COMPANY_LICENCE:
      if (actions.licenceId !== null && state.licences) {
        let licences = [...state.licences.edges];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.node.id === actions.licenceId);
          if (index > -1) {
            licences.splice(index, 1);
            return {
              ...state,
              licences: { edges: licences }
            };
          }
        }
      }
      return state;

    case EDIT_COMPANY_FACEBASE:
      if (actions.facebase !== null && actions.facebase.uuid !== null) {
        let facebases = [...state.facebases.edges];
        if (facebases.length > 0) {
          let index = facebases.findIndex(
            x => x.node.uuid === actions.facebase.uuid
          );
          if (index > -1) {
            let id = facebases[index].node.id;
            let facebase = { id: id, ...actions.facebase };
            facebases[index].node = facebase;
            return {
              ...state,
              facebases: { edges: facebases }
            };
          }
        }
      }
      return state;

    case REMOVE_COMPANY_USER:
      if (actions.userId !== null && state.users) {
        let users = [...state.users.edges];
        if (users.length > 0) {
          let index = users.findIndex(x => x.node.cognitoUuid === actions.userId);
          if (index > -1) {
            users.splice(index, 1);
            return {
              ...state,
              users: { edges: users }
            };
          }
        }
      }
      return state;

    default:
      return state;
  }
};
export default companyReducers;
